import * as _ from 'lodash';
import * as moment from 'moment';
import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { IAdpVoucherHolderRequest, IAdpVoucherHolderResponse, IBaseResponse, IDonorProfileHeaderInfo, IListItem } from '@nkr/models/index';
import { IBaseDispatchProps, ToggleType } from '../models';
import {
    IApplicationState, AppActionCreators,
    IAddVoucherHolderResponse, IVoucherHolderLookupDataResponse, AdpDonorActionCreators, IAppState
} from '@nkr/store/index';
import { Utility } from '@nkr/services/utility';
import { IValidation } from '@nkr/views/voucher-holder/add-edit/validation';
import { toast } from 'react-toastify';
import VoucherAddEditForm from '@nkr/views/voucher-holder/add-edit/add-edit-form';

interface IOwnProps extends RouteComponentProps<{ voucherHolderId: string }> {
    donorId: number,
    centerId: number,
    activeKey: string,
    isAdmin: boolean,
    isAdminLogin: boolean,
    isMicrositeParticipant: boolean,
    isFollowUpParticipant: boolean,
    isInDonorShield: boolean,
    headerInfo: IDonorProfileHeaderInfo,
    hasDataChanged: boolean,
    saveRequested: boolean,
    refreshRequested: boolean,
    onDataChanged: (hasDataChanged: boolean) => void,
    onSaveFinished: (refreshHeader: boolean) => void,
    onRefreshFinished: () => void,
    onResetDataChangedWarning: () => void,
    onTabClick: (href: string) => void,
    onUpdateForErrors: (toggleType: ToggleType, messages: string[]) => void
}

interface IStateProps {
    app: IAppState,
    groupIsSuper: boolean
}

interface IDispatchProps extends IBaseDispatchProps {
    getVoucherLookupData: () => Promise<IVoucherHolderLookupDataResponse>,
    getVoucherHolder: (id: number) => Promise<IAdpVoucherHolderResponse>,
    addVoucherHolder: (donorId: number, request: IAdpVoucherHolderRequest) => Promise<IAddVoucherHolderResponse>,
    updateVoucherHolder: (id: number, request: IAdpVoucherHolderRequest) => Promise<IBaseResponse>,
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    voucherHolderId: number,
    data: {
        abo: number,
        ckdStatus: number,
        status: number,
        type: number,
        gender: number,
        firstName: string,
        lastName: string,
        country: number,
        addressLine1: string,
        addressLine2: string,
        city: string,
        stateProvince: string,
        postalCode: string,
        phoneNumberPrimary: string,
        phoneNumberSecondary: string,
        emailPrimary: string,
        emailSecondary: string,
        birthDate: string
    }
    aboTypeList: IListItem[],
    ckdStatusList: IListItem[],
    voucherHolderStatusList: IListItem[],
    voucherHolderTypeList: IListItem[],
    genderList: IListItem[],
    countryList: IListItem[],
    validation: IValidation,
    dirty: boolean,
}

class VoucherAddEdit extends Component<TProps, IState> {
    readonly state: IState = {
        voucherHolderId: 0,
        data: {
            abo: -1,
            ckdStatus: -1,
            status: 0,
            type: -1,
            gender: -1,
            firstName: '',
            lastName: '',
            country: 1,
            addressLine1: '',
            addressLine2: '',
            city: '',
            stateProvince: '',
            postalCode: '',
            phoneNumberPrimary: '',
            phoneNumberSecondary: '',
            emailPrimary: '',
            emailSecondary: '',
            birthDate: ''
        },
        aboTypeList: [],
        ckdStatusList: [],
        voucherHolderStatusList: [],
        voucherHolderTypeList: [],
        genderList: [],
        countryList: [],
        validation: {
            type: true,
            gender: true,
            firstName: true,
            lastName: true,
            country: true,
            addressLine1: true,
            city: true,
            stateProvince: true,
            postalCode: true,
            phoneNumberPrimary: true,
            emailPrimary: true,
            emailSecondary: true,
            birthDate: true
        },
        dirty: false,
    }

    componentDidMount = () => {
        this.getData();
    }

    componentWillReceiveProps = (nextProps: Readonly<TProps>, nextContext: any) => {
        // if (this.props.saveRequested == false && nextProps.saveRequested == true) {
        //     this.handleValidate();
        // }

        if (this.props.refreshRequested == false && nextProps.refreshRequested == true) {
            this.getData();
        }
    }

    getData = () => {
        let { centerId, donorId } = this.props;

        let voucherHolderId = this.props.match.params.voucherHolderId != 'add' ? parseInt(this.props.match.params.voucherHolderId) : 0;

        this.props.showLoading('Getting data, one moment please...').then(() => {
            if (voucherHolderId > 0) {
                Promise.all([
                    this.props.getVoucherLookupData(),
                    this.props.getVoucherHolder(voucherHolderId)
                ])
                    .then(([lookupDataResponse, voucherHolderResponse]) => {
                        if (lookupDataResponse.data.success && voucherHolderResponse.data.success) {
                            let { aboTypeList, ckdStatusList, voucherHolderStatusList, voucherHolderTypeList, genderList, countryList } = lookupDataResponse.data.results;
                            let { abo, ckdStatus, status, type, gender, firstName, lastName, country, addressLine1, addressLine2, city, stateProvince, postalCode,
                                phoneNumberPrimary, phoneNumberSecondary, emailPrimary, emailSecondary, birthDate } = voucherHolderResponse.data.results;

                            this.setState({
                                voucherHolderId,
                                data: {
                                    abo, ckdStatus, status,
                                    type,
                                    gender,
                                    firstName, lastName,
                                    country,
                                    addressLine1, addressLine2, city, stateProvince, postalCode,
                                    phoneNumberPrimary, phoneNumberSecondary,
                                    emailPrimary, emailSecondary,
                                    birthDate
                                },
                                aboTypeList, ckdStatusList,
                                voucherHolderStatusList, voucherHolderTypeList, genderList, countryList
                            }, () => {
                                if (this.props.refreshRequested) {
                                    this.props.onRefreshFinished();
                                }
                            });
                        }
                    })
                    .catch(error => {
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            } else {
                Promise.all([
                    this.props.getVoucherLookupData(),
                ])
                    .then(([lookupDataResponse]) => {
                        if (lookupDataResponse.data.success) {
                            let { aboTypeList, ckdStatusList, voucherHolderStatusList, voucherHolderTypeList, genderList, countryList } = lookupDataResponse.data.results;

                            this.setState({
                                voucherHolderId,
                                aboTypeList, ckdStatusList, voucherHolderStatusList, voucherHolderTypeList, genderList,
                                countryList
                            }, () => {
                                this.props.hideLoading();
                            });
                        } else {
                            this.props.hideLoading();
                        }
                    })
                    .catch(error => {
                        this.props.hideLoading();
                    });
            }
        });
    }

    isValid = () => {
        let { type, gender, firstName, lastName, country, addressLine1, city, stateProvince, postalCode, phoneNumberPrimary, emailPrimary, birthDate } = this.state.validation;
        return type && gender && firstName && lastName && country && addressLine1 && city && stateProvince && postalCode && phoneNumberPrimary && emailPrimary && birthDate;
    }

    handleFieldChange = (name: string, value: any) => {
        let data = _.cloneDeep(this.state.data);

        if (name == 'type' || name == 'gender' || name == 'country') {
            data[name] = parseInt(value);
        } else {
            data[name] = value;
        }

        this.setState({
            data
        });
    }

    handleSubmit = () => {
        let { type, gender, firstName, lastName, country, addressLine1, city, stateProvince, postalCode,
            phoneNumberPrimary, emailPrimary, emailSecondary, birthDate } = this.state.data;

        let validation: IValidation = {
            type: type >= 0,
            gender: gender >= 0,
            firstName: firstName != '',
            lastName: lastName != '',
            country: country >= 0,
            addressLine1: addressLine1 != '',
            city: city != '',
            stateProvince: stateProvince != '',
            postalCode: postalCode != '',
            phoneNumberPrimary: phoneNumberPrimary != '',
            emailPrimary: Utility.isValidEmail(emailPrimary),
            emailSecondary: emailSecondary != '' ? Utility.isValidEmail(emailSecondary) : true,
            birthDate: moment(birthDate).isValid()
        };

        this.setState({
            validation,
            dirty: true
        }, () => {
            if (this.isValid()) {
                let request: IAdpVoucherHolderRequest = {
                    ...this.state.data,
                    abo: this.state.data.abo != -1 ? this.state.data.abo : null,
                    ckdStatus: this.state.data.ckdStatus != -1 ? this.state.data.ckdStatus : null,
                    status: this.state.data.status != -1 ? this.state.data.status : null,
                    isAdmin: this.props.isAdminLogin
                }

                this.props.showLoading('Saving voucher data, one moment please...').then(() => {
                    if (this.state.voucherHolderId > 0) {
                        this.props.updateVoucherHolder(this.state.voucherHolderId, request)
                            .then(response => {
                                if (response.data.success) {
                                    toast.success('Voucher holder updated successfully');
                                }
                            })
                            .finally(() => {
                                this.props.hideLoading();
                            });
                    } else {
                        this.props.addVoucherHolder(this.props.donorId, request)
                            .then(response => {
                                if (response.data.success) {
                                    toast.success('Voucher holder added successfully', {
                                        autoClose: 1500,
                                        onClose: () => {
                                            window.location.href = `/center/${this.props.centerId}/donor/${this.props.donorId}/voucher/${response.data.results}`;
                                        }
                                    });
                                }
                            })
                            .finally(() => {
                                this.props.hideLoading();
                            });
                    }
                });
            }
        });
    }

    handleCancel = () => {
        window.location.href = `/center/${this.props.centerId}/donor/${this.props.donorId}/profile/vouchers`;
    }

    render = () => {
        if (this.props.headerInfo == null)
            return null;

        let isValid = this.isValid();

        return (
            <div className='container' style={{ paddingTop: 20 }}>
                <VoucherAddEditForm
                    data={this.state.data}
                    voucherHolderId={this.state.voucherHolderId}
                    isAdmin={this.props.isAdmin}
                    isAdminLogin={this.props.isAdminLogin}
                    isValid={isValid}
                    validation={this.state.validation}
                    dirty={this.state.dirty}
                    genderList={this.state.genderList}
                    countryList={this.state.countryList}
                    aboTypeList={this.state.aboTypeList}
                    ckdStatusList={this.state.ckdStatusList}
                    voucherHolderStatusList={this.state.voucherHolderStatusList}
                    voucherHolderTypeList={this.state.voucherHolderTypeList}
                    showActions={false}
                    onAction={() => null}
                    onFieldChange={this.handleFieldChange}
                    onSave={this.handleSubmit}
                    onCancel={this.handleCancel} />
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app,
        groupIsSuper: appState.app.user.group.isSuper
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getVoucherLookupData: () => {
            return dispatch(AdpDonorActionCreators.getVoucherHolderLookupData());
        },
        getVoucherHolder: (id) => {
            return dispatch(AdpDonorActionCreators.getVoucherHolderById(id));
        },
        addVoucherHolder: (donorId, request) => {
            return dispatch(AdpDonorActionCreators.addVoucherHolder(donorId, request));
        },
        updateVoucherHolder: (id, request) => {
            return dispatch(AdpDonorActionCreators.updateVoucherHolder(id, request));
        },
    };
}

export default withRouter(connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(VoucherAddEdit));